export default {
  'Animate old photos': 'Eski fotoğrafları canlandırın',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'AI teknolojisi ile fotoğraflarınızdaki yüzleri canlandırın, canlı videolar oluşturun.',
  'Upload a photo': 'Bir fotoğraf yükle',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    'Not: Lütfen seçtiğiniz fotoğraflardaki yüzün lense baktığından emin olun, aksi takdirde başarıyla işlenemez.',
  'Uploaded successfully!': 'Başarıyla yüklendi!',
  'Please select a template below': 'Lütfen aşağıdan bir şablon seçin',
  'Choose a GIF': 'Bir GIF seçin',
  'Use this template': 'Bu şablonu kullanın',
  'Verify successfully! You will':
    'Başarıyla doğrulayın! {{email}} ile kısa süre içinde videoyu alacaksınız.',
  'You will': '{{email}} ile kısa süre içinde videoyu alacaksınız.',
  'What you should expect to happen next':
    'Bundan sonra olmasını beklemeniz gerekenler:',
  'We will process your photo into a dynamic video.':
    'Fotoğrafınızı dinamik bir video olarak işleyeceğiz.',
  'After processing, we will send the video to your email.':
    'İşlemden sonra videoyu e-postanıza göndereceğiz.',
  'You can check the video in your email.':
    'E-postanızdaki videoyu kontrol edebilirsiniz.',
  'Your video will be delivered via email':
    'Videonuz e-posta yoluyla teslim edilecek',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    'Dinamik bir videoyu sentezlemek 20-30 dakika sürer, lütfen sabırlı olun. Gizliliğinizi korumak için, yüklenen resimler işlem bittikten sonra otomatik olarak silinecektir.',
  'Your Email': 'E-posta adresiniz',
  'Last Name': 'Adı',
  'First Name': 'Soyadı',
  'Go back': 'Geri git',
  'Invalid email address': 'Geçersiz e-posta adresi',
  'Enter verification code': 'Doğrulama kodunu girin',
  'Enter the verification code that we sent to':
    "{{email}}'e gönderdiğimiz doğrulama kodunu girin.",
  Resend: 'Yeniden gönder',
  'Verification code': 'Doğrulama kodu',
  'Resend after': '{{num}} saniye sonra yeniden gönder',
  'The verification code is invalid. You can request a new one.':
    'Doğrulama kodu geçersiz. Yeni bir tane isteyebilirsiniz.',
  'Synthesize Video': 'Videoyu Sentezle',
  Next: 'Sonraki',
  'Too many attempts, please try again later.':
    'Çok fazla denendi. Lütfen daha sonra tekrar deneyin',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
